import { MSMRequest } from "../../../../api/msm";
import PopupText from "../../../PopupText";
import Text from "../../../Text";
import * as BancaPartnerStyles from "./banca-partner.module.scss";
import { yupResolver } from "@hookform/resolvers/yup";
import classNames from "classnames";
import parse from "html-react-parser";
import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { IMaskInput } from "react-imask";
import * as yup from "yup";

const schemaBancaPartner = yup.object().shape({
  Nome: yup
    .string()
    .min(2, 'Il campo "Nome" deve contenere almeno 2 caratteri')
    .trim()
    .required('Il campo "Nome" è obbligatorio')
    .matches(/^[aA-zZ\s]+$/, 'Il campo "Nome" può contenere solo lettere'),
  Cognome: yup
    .string()
    .min(2, 'Il campo "Cognome" deve contenere almeno 2 caratteri')
    .trim()
    .required('Il campo "Cognome" è obbligatorio')
    .matches(/^[aA-zZ\s]+$/, 'Il campo "Cognome" può contenere solo lettere'),
  Banca: yup
    .string()
    .min(2, 'Il campo "Banca" deve contenere almeno 2 caratteri')
    .trim()
    .required('Il campo "Banca" è obbligatorio'),
  Telefono: yup
    .string()
    .required('Il campo "Telefono" è obbligatorio')
    .matches(
      /^(?:\+39)?\d{9,10}$/,
      'Il campo "Telefono" deve essere un numero valido'
    ),
  Posizione: yup.string().trim().nullable().optional(),
  Email: yup.string().email().nullable().optional(),
  Note: yup.string().nullable().optional(),
  AccettaTrattamentoDati: yup
    .boolean()
    .oneOf([true], "Devi accettare la privacy policy per inviare il modulo"),
});

function BancaPartner({ labelCta, consenso, setSettingsModal }) {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    control,
    reset,
    watch,
  } = useForm({
    resolver: yupResolver(schemaBancaPartner),
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      Nome: "",
      Cognome: "",
      Banca: "",
      Telefono: "",
      Posizione: "",
      Email: "",
      Note: "",
      AccettaTrattamentoDati: false,
    },
  });

  const watchs = watch();

  const onSubmit = async (data) => {
    const response = await MSMRequest("ContattoNuoveBanche", data);
    if (response.success) {
      const BodyContent = (
        <Text content="Il messaggio è stato inviato con successo. A breve sarai ricontattato." />
      );
      setSettingsModal({
        title: "Grazie",
        content: BodyContent,
      });
      reset();
    } else {
      const BodyContent = (
        <Text content="Si è verificato un errore. Riprova più tardi." />
      );
      setSettingsModal({
        title: "Attenzione",
        content: BodyContent,
      });
    }
  };

  const onError = (errors, e) => {
    const BodyContent = (
      <>
        {Object.keys(errors).map((key, index) => {
          return <p key={index}>{errors[key].message}</p>;
        })}
      </>
    );
    setSettingsModal({
      title: "Attenzione",
      content: BodyContent,
    });
  };

  return (
    <Form className={BancaPartnerStyles.form} autoComplete="off">
      <Row className={BancaPartnerStyles.formRow}>
        <Col md={4}>
          <div
            className={classNames(BancaPartnerStyles.field, {
              [BancaPartnerStyles.fieldError]: errors.Nome,
              [BancaPartnerStyles.fieldValid]:
                !errors.Nome && watchs.Nome?.length > 0,
            })}
          >
            <label
              htmlFor="Nome"
              className={classNames({
                [BancaPartnerStyles.filled]: watchs.Nome?.length > 0,
              })}
            >
              Nome*
            </label>
            <input type="text" {...register("Nome")} />
          </div>
        </Col>
        <Col md={4}>
          <div
            className={classNames(BancaPartnerStyles.field, {
              [BancaPartnerStyles.fieldError]: errors.Cognome,
              [BancaPartnerStyles.fieldValid]:
                !errors.Cognome && watchs.Cognome?.length > 0,
            })}
          >
            <label
              htmlFor="Cognome"
              className={classNames({
                [BancaPartnerStyles.filled]: watchs.Cognome?.length > 0,
              })}
            >
              Cognome*
            </label>
            <input type="text" {...register("Cognome")} />
          </div>
        </Col>
        <Col md={4}>
          <div
            className={classNames(BancaPartnerStyles.field, {
              [BancaPartnerStyles.fieldError]: errors.Banca,
              [BancaPartnerStyles.fieldValid]:
                !errors.Banca && watchs.Banca?.length > 0,
            })}
          >
            {" "}
            <label
              htmlFor="Banca"
              className={classNames({
                [BancaPartnerStyles.filled]: watchs.Banca?.length > 0,
              })}
            >
              Banca*
            </label>
            <input type="text" {...register("Banca")} />
          </div>
        </Col>
        <Col md={4}>
          <div
            className={classNames(BancaPartnerStyles.field, {
              [BancaPartnerStyles.fieldError]: errors.Telefono,
              [BancaPartnerStyles.fieldValid]:
                !errors.Telefono && watchs.Telefono?.length > 0,
            })}
          >
            <label
              htmlFor="Telefono"
              className={classNames({
                [BancaPartnerStyles.filled]: watchs.Telefono?.length > 0,
              })}
            >
              Telefono*
            </label>
            <Controller
              name="Telefono"
              control={control}
              valueAsNumber={true}
              render={({ field }) => (
                <IMaskInput
                  mask={Number}
                  unmask={true}
                  onAccept={(value, mask) => {
                    field.onChange(value);
                  }}
                />
              )}
            />
          </div>
        </Col>
        <Col md={4}>
          <div className={BancaPartnerStyles.field}>
            {" "}
            <label
              htmlFor="Posizione"
              className={classNames({
                [BancaPartnerStyles.filled]: watchs.Posizione?.length > 0,
              })}
            >
              Posizione
            </label>
            <input type="text" {...register("Posizione")} />
          </div>
        </Col>
        <Col md={4}>
          <div
            className={classNames(BancaPartnerStyles.field, {
              [BancaPartnerStyles.fieldError]: errors.Email,
              [BancaPartnerStyles.fieldValid]:
                !errors.Email && watchs.Email?.length > 0,
            })}
          >
            <label
              htmlFor="Email"
              className={classNames({
                [BancaPartnerStyles.filled]: watchs.Email?.length > 0,
              })}
            >
              E-mail
            </label>
            <input type="email" {...register("Email")} />
          </div>
        </Col>
        <Col md={12}>
          <div className={BancaPartnerStyles.field}>
            <textarea {...register("Note")} placeholder="Messaggio" />
          </div>
        </Col>
        <Col md={12}>
          <div
            className={classNames(BancaPartnerStyles.fieldCheckbox, {
              [BancaPartnerStyles.fieldError]: errors?.AccettaTrattamentoDati,
            })}
          >
            <input type="checkbox" {...register("AccettaTrattamentoDati")} />
            <label
              htmlFor="AccettaTrattamentoDati"
              className={BancaPartnerStyles.smallText}
            >
              {parse(consenso.label, {
                replace: (domNode) => {
                  if (
                    domNode.attribs &&
                    domNode.attribs["data-config"] &&
                    domNode.attribs["data-config"].length > 0
                  ) {
                    const dataConfigParsed = JSON.parse(
                      domNode.attribs["data-config"]
                    );
                    switch (dataConfigParsed.type) {
                      case "open-popup":
                        return (
                          <button
                            className={BancaPartnerStyles.trigger}
                            onClick={(e) => {
                              e.preventDefault();
                              const BodyContent = (
                                <>
                                  <PopupText content={consenso.popup.testo} />
                                </>
                              );
                              setSettingsModal({
                                title: consenso.popup.titolo,
                                content: BodyContent,
                              });
                            }}
                          >
                            {dataConfigParsed.label}
                          </button>
                        );
                      default:
                        break;
                    }
                  }
                },
              })}
            </label>
          </div>
        </Col>
        <Col md={12}>
          <button
            type="submit"
            onClick={handleSubmit(onSubmit, onError)}
            className={BancaPartnerStyles.button}
            disabled={isSubmitting}
          >
            {labelCta}
          </button>
        </Col>
      </Row>
    </Form>
  );
}

export default BancaPartner;
